// Client entry. Boots the engine + renderer; `window.voxel` is the debug/E2E API.
import { boot } from './boot';

boot().catch((err) => {
  const app = document.getElementById('app');
  if (app) {
    app.innerHTML = `<pre style="color:#e77;padding:24px;white-space:pre-wrap">TerraForge failed to boot:\n${String(err instanceof Error ? err.stack : err)}</pre>`;
  }
  throw err;
});
